import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered By 上海矩阵未来信息技术有限公司"
      links={[]}
    />
  );
};

export default Footer;
